import { writePsd } from 'ag-psd';

/**
 * 将图片源转换为Canvas
 * @param source 图片源（URL、Blob或Image）
 * @returns Promise解析为Canvas元素
 */
export const imageToCanvas = async (source: string | Blob | HTMLImageElement): Promise<HTMLCanvasElement> => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'anonymous';

  // 处理不同类型的输入
  if (typeof source === 'string') {
    img.src = source;
  } else if (source instanceof Blob) {
    img.src = URL.createObjectURL(source);
  } else if (source instanceof HTMLImageElement) {
    img.src = source.src;
  } else {
    return reject(new Error('不支持的图片源类型'));
  }

  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return reject(new Error('无法获取2D上下文'));
    }

    ctx.drawImage(img, 0, 0);
    resolve(canvas);

    // 清理Blob URL
    if (source instanceof Blob) {
      URL.revokeObjectURL(img.src);
    }
  };

  img.onerror = (err) => {
    reject(new Error(`图片加载失败: ${err}`));
  };
});

/**
 * 导出PSD文件
 * @param bgImage 背景图（URL、Blob或Image）
 * @param modelImage 模型截图（Blob）
 */
export const exportToPSD = async (bgImage: string | Blob, modelImage: string | Blob) => {
  // 1. 转换图片为 Canvas
  const bgCanvas = await imageToCanvas(bgImage);
  const modelCanvas = await imageToCanvas(modelImage);

  // 2. 构建 PSD 对象
  const psd = {
    width: bgCanvas.width,
    height: bgCanvas.height,
    children: [
      {
        name: '背景层',
        canvas: bgCanvas,
        top: 0,
        left: 0,
        bottom: bgCanvas.height,
        right: bgCanvas.width,
        opacity: 1,
      },
      {
        name: '3D模型层',
        canvas: modelCanvas,
        left: Math.floor((bgCanvas.width - modelCanvas.width) / 2),
        top: Math.floor((bgCanvas.height - modelCanvas.height) / 2),
        opacity: 1,
      },
    ],
  };

  // 3. 生成 PSD 数据
  const buffer = writePsd(psd, {
    generateThumbnail: true, // 自动生成缩略图
    trimImageData: true,     // 优化透明像素
  });

  // 4. 创建下载
  const blob = new Blob([buffer], { type: 'application/psd' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'design.psd';
  document.body.appendChild(a);
  a.click();

  // 清理资源
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
};
